// Content for /doelgroepen/* pages (audience landing pages).

export const DOELGROEPEN = {
  paardeneigenaren: {
    slug: "paardeneigenaren",
    eyebrow: "Doelgroep · Paardeneigenaren",
    title: "EquiSight voor paardeneigenaren.",
    subtitle:
      "Alles wat je vandaag verspreid bijhoudt — WhatsApp, schoenendoos, losse apps — straks in één paardendossier per paard.",
    primaryCTA: { label: "Start gratis", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk functies →", href: "/functies" },
    audience: "Voor paardeneigenaren met één of meerdere paarden, ongeacht discipline.",
    features: [
      "Eén compleet dossier per paard",
      "Gezondheid · hoefsmid · tandarts · fysio",
      "Agenda met slimme herinneringen",
      "Foto's, notities en historie zonder limiet",
      "Backup van al je data bij Premium",
      "Deel met trainer en verzorger",
    ],
    faq: [
      {
        q: "Heb ik er één paard of meerdere paarden voor nodig?",
        a: "Beide. Basic (€0) ondersteunt 1 paard. Vanaf Premium (€4,99/maand) onbeperkt paarden.",
      },
    ],
  },
  manegehouders: {
    slug: "manegehouders",
    eyebrow: "Doelgroep · Manegehouders",
    title: "EquiSight voor manegehouders.",
    subtitle:
      "Maak je manege digitaal toegankelijk voor iedere ruiter. Lesplanning, ruiter administratie, paardenbeheer — zonder gevoelige staldata te delen.",
    primaryCTA: { label: "Vraag toegang aan", href: "/#waitlist" },
    secondaryCTA: { label: "Manege software →", href: "/functies/manege" },
    audience: "Voor maneges, pensionstallen en rij(les)scholen.",
    features: [
      "Lesplanning",
      "Ruiter administratie",
      "Paardenbeheer met foto's",
      "Communicatie met ruiters",
      "Alleen-lezen voor privacy-gevoelige data",
      "Gebruikersbeheer met rollen",
    ],
    faq: [
      {
        q: "Wat ziet een manegeruiter wel en niet?",
        a: "Een manegeruiter ziet alleen wat jij vrijgeeft (foto, naam, eventueel discipline). Medische data blijft bij de eigenaar en het stalbeheer.",
      },
    ],
  },
  wedstrijdruiters: {
    slug: "wedstrijdruiters",
    eyebrow: "Doelgroep · Wedstrijdruiters",
    title: "EquiSight voor wedstrijdruiters.",
    subtitle:
      "Plan wedstrijden, analyseer protocollen en volg de Equestrian Performance Index. Word beter met data — niet met losse vermoedens.",
    primaryCTA: { label: "Start voor wedstrijdseizoen", href: "/#waitlist" },
    secondaryCTA: { label: "Wedstrijdanalyse →", href: "/functies/wedstrijdanalyse" },
    audience: "Voor wedstrijdruiters in dressuur, springen, eventing, endurance en western.",
    features: [
      "Wedstrijdplanning",
      "Startlijst meldingen",
      "Protocol scannen (voor- en achterkant)",
      "Scores per onderdeel",
      "Jurycommentaar samenvatten",
      "Trends per combinatie",
      "EPI — Equestrian Performance Index",
    ],
  },
  dressuurruiters: {
    slug: "dressuurruiters",
    eyebrow: "Doelgroep · Dressuurruiters",
    title: "EquiSight voor dressuurruiters.",
    subtitle:
      "Scan je dressuurprotocol, zie scores per onderdeel en jurycommentaar, en ontdek waar je punten laat liggen. Voor KNHS en FEI proeven.",
    primaryCTA: { label: "Probeer protocol analyse", href: "/#waitlist" },
    secondaryCTA: { label: "Dressuur →", href: "/disciplines/dressuur" },
    audience: "Voor dressuurruiters van klasse B tot Grand Prix.",
    features: [
      "KNHS en FEI proeven",
      "Voor- en achterkant scannen",
      "Scores per onderdeel",
      "Jurycommentaar groeperen",
      "EPI voor je combinatie",
      "Trainingsdoelen koppelen",
    ],
  },
  springruiters: {
    slug: "springruiters",
    eyebrow: "Doelgroep · Springruiters",
    title: "EquiSight voor springruiters.",
    subtitle:
      "Plan wedstrijden, ontvang startlijst meldingen, registreer rondes en volg training en gezondheid van je springpaarden.",
    primaryCTA: { label: "Start voor springseizoen", href: "/#waitlist" },
    secondaryCTA: { label: "Springen →", href: "/disciplines/springen" },
    audience: "Voor springruiters in alle klasses, ponyruiters en eventers.",
    features: [
      "Wedstrijdplanning per paard",
      "Startlijst meldingen",
      "Rondes registreren",
      "Training koppelen aan wedstrijdresultaat",
      "Gezondheidsdossier",
      "Hoefsmid en dierenarts agenda",
    ],
  },
  fokkers: {
    slug: "fokkers",
    eyebrow: "Doelgroep · Fokkers",
    title: "EquiSight voor fokkers.",
    subtitle:
      "Beheer cyclus, dekkingen, dracht en veulens in één tijdlijn. Houd stamboom, scans en geboortes overzichtelijk bij.",
    primaryCTA: { label: "Start als fokker", href: "/#waitlist" },
    secondaryCTA: { label: "Fokkerij software →", href: "/functies/fokkerij" },
    audience: "Voor fokkers, merriehouders en stallen met meerdere merries.",
    features: [
      "Cyclus tracking per merrie",
      "Hengstigheid en inseminatie",
      "Drachtcontroles en echo's",
      "Stamboom",
      "Veulenontwikkeling",
      "Overzicht alle drachtige merries",
    ],
  },
  hoefsmeden: {
    slug: "hoefsmeden",
    eyebrow: "Doelgroep · Hoefsmeden",
    title: "EquiSight voor hoefsmeden.",
    subtitle:
      "Hoefsmid software met agenda, klantbeheer, voor- en na foto's, ETA notificaties en behandelhistorie. Werk professioneler.",
    primaryCTA: { label: "Start als hoefsmid", href: "/#waitlist" },
    secondaryCTA: { label: "Hoefsmid module →", href: "/functies/hoefsmid" },
    audience: "Voor hoefsmeden, hoefspecialisten en barhoof-praktijken.",
    features: [
      "Agenda en routeplanning",
      "Klantbeheer per paard",
      "Voor- en na foto's",
      "ETA naar klant",
      "Behandelhistorie",
      "Facturering en exports",
    ],
  },
  dierenartsen: {
    slug: "dierenartsen",
    eyebrow: "Doelgroep · Dierenartsen",
    title: "EquiSight voor dierenartsen.",
    subtitle:
      "Bouw een medisch dossier per paard: vaccinaties, medicatie, bevindingen, foto's en historie. Werk samen met de eigenaar.",
    primaryCTA: { label: "Start als dierenarts", href: "/#waitlist" },
    secondaryCTA: { label: "Dierenarts module →", href: "/functies/dierenarts" },
    audience: "Voor paarden dierenartsen, mobiele klinieken en specialisten.",
    features: [
      "Medisch dossier per paard",
      "Vaccinaties & medicatie",
      "Bevindingen met foto/video",
      "Behandelhistorie",
      "Direct communiceren met eigenaar",
      "GDPR-conform binnen EU",
    ],
  },
  trainers: {
    slug: "trainers",
    eyebrow: "Doelgroep · Trainers",
    title: "EquiSight voor trainers en instructeurs.",
    subtitle:
      "Zet doelen, geef feedback, volg progressie en analyseer protocollen. Voor één of meerdere ruiters.",
    primaryCTA: { label: "Start als trainer", href: "/#waitlist" },
    secondaryCTA: { label: "Trainer module →", href: "/functies/trainer" },
    audience: "Voor instructeurs, trainers en coaches.",
    features: [
      "Ruiters en paarden koppelen",
      "Trainingsdoelen",
      "Feedback geven",
      "Wedstrijdresultaten analyseren",
      "Progressie per combinatie",
      "Protocolanalyses in training",
    ],
  },
};

export default DOELGROEPEN;
